import React from "react";

const wrapperClasses = "flex justify-between items-center";
const leftClasses = "flex items-center gap-2";
const titleClasses =
  "text-content font-heading text-base font-semibold leading-none flex items-center";
const rightClasses = "flex items-center";
const iconClasses = "flex items-center [&_svg]:block";

const CardHeader = ({
  icon,
  title,
  rightContent,
  className = "",
}) => {
  return (
    <div className={`${wrapperClasses} ${className}`}>
      <div className={leftClasses}>
        {icon && <span className={iconClasses}>{icon}</span>}
        <span className={titleClasses}>{title}</span>
      </div>

      {rightContent && (
        <div className={rightClasses}>
          {rightContent}
        </div>
      )}
    </div>
  );
};

export default CardHeader;
